import { useReducer } from "react";
import { SignatureContext } from "./SignatureContext";
import { initialStateSignature, signatureReducer } from "./SignatureReducer";
import PropTypes from "prop-types";
import { useState } from "react";

// Crear el contexto
export const SignatureProvider = ({ children }) => {
  // const [fieldColorsState, fieldColorsDispatch] = useReducer(fieldColorsReducer, initialStateFieldColors);
  const [signatureState, signatureDispatch] = useReducer(signatureReducer, initialStateSignature); // Reducer con estado inicial
  const [fieldRef, setFieldRef] = useState(null);
  
  return (
    <SignatureContext.Provider
      value={{
        signatureState,
        signatureDispatch,
        fieldRef,
        setFieldRef,
      }}
    >
      {children}
    </SignatureContext.Provider>
  );
};

SignatureProvider.propTypes = {
  children: PropTypes.node.isRequired,
};